export * from './ActorRdfUpdateQuads';
export * from './ActorRdfUpdateQuadsDestination';
export * from './IQuadDestination';
